
































































































































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  reactive
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import FormHeader from '../../molecules/FormHeader.vue';
import Snackbar from '../../molecules/Snackbar.vue';
import router from '../../../router';
export default createComponent({
  data(){
    return{
      attendanceItem:[
        {text:"遅刻", value:"008002"},
        {text:"早退", value:"008003"}
      ],
    }
  },
  setup() {
    const state = reactive({
      attendanceReason:'',
      validationMessage:{
        attendanceRequired:""
      }
    })
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
     const inputDetailAppicationDate = (e:string) => {
      companyRecruitment.inputDetailAppicationDate(e)
    }
    const jobInfor = computed(() => companyRecruitment.jobDetailApplication);
    const jobInforDetail = companyRecruitment.jobInforDetail
    const listDate = computed(() => companyRecruitment.jobDetailApplication.listDate);
    const getApplicationInfo = companyRecruitment.getApplicationInfo
    const updateUserEvaluation = companyRecruitment.updateUserComment
    const common_id = window.location.pathname.split('/')[3]
    const recruitment = window.location.pathname.split('/')[5]
   
    const toUserDetail = (customerId: any, jobId: any, commonId: any) => {
      router.push(`/company_detail/user/customer_id/${customerId}/job_application_id/${jobId}/common_id/${commonId}`)
    }

    const formatDate = (date: string) => displayui.formatDate(date)

    const attendanceDialog = computed(() => displayui.dialogAttendance);
    const abcenseDialog = computed(() => displayui.dialogAbsence);
    let selectedItem:any = null
    const openAttendanceDialog = ((item: any) => {
      state.validationMessage.attendanceRequired = '';
      selectedItem = item
      displayui.openAttendanceDialog()
    });
    const openAbcenseDialog = ((item: any) => {
      state.validationMessage.attendanceRequired = '';
      selectedItem = item
      displayui.openAbsenceDialog()
    });

    const updateAttendance = (() => {
      if(!state.attendanceReason){
        state.validationMessage.attendanceRequired = '勤怠理由は必須です。';  
        return;
      }

      if(selectedItem){
        if(disabledChangeAttendance(selectedItem)){
          state.validationMessage.attendanceRequired = '勤務時間前・勤務時間後は修正できません。';
          return
        }
        companyRecruitment.updateAttendance(selectedItem, state.attendanceReason)
        companyRecruitment.jobSearchInformationDetail(common_id, recruitment, companyRecruitment.jobDetailApplication.startDate)
      }
      displayui.closeAttendanceDialog()
    });
    const updateAbcense = (() => {
      if(selectedItem){
        if(disabledChangeAttendance(selectedItem)){
          state.validationMessage.attendanceRequired = '勤務時間前・勤務時間後は修正できません。';
          return
        }
        companyRecruitment.updateAttendance(selectedItem, "008004")
        companyRecruitment.jobSearchInformationDetail(common_id, recruitment, companyRecruitment.jobDetailApplication.startDate)
      }
      displayui.closeAbsenceDialog()
    });

    

    const disabledChangeAttendance = ((item:any) =>{
      var nowDate = new Date();
      var workStartDate = new Date(item.work_start_date + " " + item.start_time + ":00")
      var workEndDate = new Date(item.work_start_date + " " + item.end_time + ":00")
      return (nowDate < workStartDate || workEndDate <= nowDate || !(item.code == "004002" || item.code == "004006" || item.code == "004007"));
    });

    const closeAttendanceDialog = computed(() => displayui.closeAttendanceDialog);
    const closeAbcenseDialog = computed(() => displayui.closeAbsenceDialog)
    return {
      jobInfor,
      jobInforDetail,
      getApplicationInfo,
      toUserDetail,
      updateUserEvaluation,
      listDate,
      formatDate,
      inputDetailAppicationDate,
      openAttendanceDialog,
      closeAttendanceDialog,
      attendanceDialog,
      openAbcenseDialog,
      closeAbcenseDialog,
      abcenseDialog,
      updateAttendance,
      state,
      updateAbcense,
      disabledChangeAttendance,
    };
  },
  components: {
    FormHeader,
    Snackbar,
  },
})
